module.exports = __webpack_public_path__ + "img/手势识别--互动玩法--比枪后gif.bd54bbc3.gif";